import { Dialog, DialogContent, DialogTitle, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { AsyncCallArgs, iTxt, useAsyncCall } from "@duosoftbg/nacid-components";
import React, { useEffect } from "react";
import { searchCountryQFData } from "../../../axios/api/services";
import { toast } from "react-toastify";
import { useTranslation, getI18n } from "react-i18next";
import { useState } from "react";
import { CountryDetailsLong } from "../../../types/QFDataTypes";
import { Box } from "@mui/system";
import { QFTables } from "./QFTables";

interface CountryDialogProps {
  countryId: string | null;
  onClose: () => void;
}

export const DialogQF = ({ countryId, onClose }: CountryDialogProps) => {
  const { t } = useTranslation();
  const [data, setData] = useState<CountryDetailsLong | null>(null);
  const { asyncCall } = useAsyncCall();

  const search = (countryId: string) => {
    const asyncSearch: AsyncCallArgs = {
      withGlobalBackdrop: true,
      promise: searchCountryQFData(countryId),
      processResponseErrors: true,
      onSuccess: (response: any) => {
        setData(response);
      },
      onError: () => {
        toast.error(t("m.search.error"));
      },
    };
    asyncCall(asyncSearch);
  };

  useEffect(() => {
    if (countryId) {
      search(countryId);
    } else {
      setData(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countryId]);
  if (data === null) {
    return null;
  }

  return (
    <Dialog
      open={countryId !== null}
      onClose={onClose}
      PaperProps={{
        style: {
          backgroundColor: "#fff",
          padding: "10px",
          borderRadius: "12px",
          overflow: "hidden",
          maxHeight: "90vh",
          display: "flex",
          maxWidth: "100vw",
          minWidth: "40%",
          flexDirection: "column",
        },
      }}
    >
      <DialogTitle>
        <IconButton aria-label="close" onClick={onClose} sx={{ position: "absolute", right: 8, top: 8 }}>
          <CloseIcon />
        </IconButton>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "20px",
            paddingBottom: "20px",
          }}
        >
          <Box
            component="img"
            src={data?.country?.id ? `https://flagcdn.com/w40/${data?.country.id.toLowerCase()}.png` : undefined}
            alt="-"
            sx={{
              width: "48px",
              height: "32px",
              borderRadius: "4px",
              boxShadow: "0 0 2px #aaa",
            }}
          />
          <Typography
            sx={{
              fontSize: "24px",
              fontWeight: 600,
              lineHeight: 1,
              color: "#464646",
            }}
          >
            {iTxt(getI18n().language, data?.country.name, data?.country.nameEn)}
          </Typography>
        </Box>
        <div style={{ width: "100%", height: "2px", backgroundColor: "#A7AAB1" }}></div>
        <Box
          sx={{
            fontSize: "15px",
            fontStyle: "italic",
            fontWeight: 500,
            lineHeight: 1,
            textAlign: "center",
            textIndent: "12px",
            paddingTop: "10px",
            paddingBottom: "10px",
            paddingLeft: "0px",
            paddingRight: "0px",
            color: "#464646",
          }}
        >
          {iTxt(getI18n().language, data?.systemSummary, data?.systemSummaryEn)}
        </Box>
        <div style={{ width: "100%", height: "2px", backgroundColor: "#A7AAB1" }}></div>
      </DialogTitle>
      <DialogContent>
        <QFTables data={data} />
      </DialogContent>
    </Dialog>
  );
};
export default DialogQF;
